import { AxiosInstance } from "axios";
import type {
  OrgSelectionApi,
  SelectOrgRequest,
  SourceOrg,
} from "../source-settings/OrgSelection.types";
import type {
  Project4TWBucket,
  Project4TWProject,
} from "./Project4TWSourceSettings.types";

export class Project4TWSourceSettingsApi implements OrgSelectionApi {
  constructor(private readonly client: AxiosInstance) {}

  /**
   * Environments (organisations) the connection's discovery token can see.
   * Only meaningful between the first OAuth leg and org selection.
   */
  async getOrgs(boardId: string, connectionId: string): Promise<SourceOrg[]> {
    const response = await this.client.get<SourceOrg[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/p4tw/orgs`,
    );
    return response.data;
  }

  /**
   * Save the chosen environment against the connection.
   * Returns the provider auth URL for the second, environment-scoped OAuth leg.
   */
  async selectOrg(
    boardId: string,
    connectionId: string,
    request: SelectOrgRequest,
  ): Promise<{ authUrl: string }> {
    const response = await this.client.post<{ authUrl: string }>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/p4tw/select-org`,
      request,
    );
    return response.data;
  }

  async getProjects(
    boardId: string,
    connectionId: string,
  ): Promise<Project4TWProject[]> {
    const response = await this.client.get<Project4TWProject[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/p4tw/projects`,
    );
    return response.data;
  }

  async getProjectBuckets(
    boardId: string,
    connectionId: string,
    projectId: string,
  ): Promise<Project4TWBucket[]> {
    const response = await this.client.get<Project4TWBucket[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/p4tw/projects/${encodeURIComponent(projectId)}/buckets`,
    );
    return response.data;
  }
}
